import React, { useContext, useEffect, useState } from 'react'
import { LangContext } from '../../context/lang-context'
import FormSkel from './FormSkel'

export default function MaintenanceModal({ maintenanceData, handleSubmit, handleClose }) {
  const { TRL_Pack } = useContext(LangContext)
  const [name, setName] = useState(maintenanceData?.Name || "")

  useEffect(() => {
    setName(maintenanceData?.Name || "")
  }, [maintenanceData])

  return (
    <FormSkel
      headerText={
        maintenanceData
          ? TRL_Pack.maintenances.editItemHeader
          : TRL_Pack.maintenances.newItemHeader
      }
      handleClose={handleClose}
      data={maintenanceData}
    >
      <form onSubmit={handleSubmit} id="modal-form" autoComplete="off">
        <div className="mb-3">
          <label className="h6">
            {TRL_Pack.maintenances.properties.maintenanceName}
          </label>
          <input
            name="name"
            className={`mt-2 form-control form-control-sm ${!name.trim() && "invalid-input"}`}
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            required
          />
        </div>
        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="HasEVADTS" defaultChecked={maintenanceData?.HasEVADTS} />
          <label className="form-check-label">EVADTS</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsCoffee" defaultChecked={maintenanceData?.IsCoffee} />
          <label className="form-check-label">Kawa</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsSnack" defaultChecked={maintenanceData?.IsSnack} />
          <label className="form-check-label">Snack</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsCalcDiff" defaultChecked={maintenanceData?.IsCalcDiff} />
          <label className="form-check-label">Rozliczanie poprzez odejmowanie sum sprzedaży ilościowej na wyborze</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsTotalCoinsRequired" defaultChecked={maintenanceData?.IsTotalCoinsRequired} />
          <label className="form-check-label">Spisywanie licznika gotówkowego wymagane podczas wybierania monet</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsTotalSalesRequired" defaultChecked={maintenanceData?.IsTotalSalesRequired} />
          <label className="form-check-label">Spisywanie licznika ilościowego wymagane podczas wybierania monet</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsCorrectionCommentRequired" defaultChecked={maintenanceData?.IsCorrectionCommentRequired} />
          <label className="form-check-label">Komentarz do korekty jest wymagany</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="ShowMachineName" defaultChecked={maintenanceData?.ShowMachineName} />
          <label className="form-check-label">Wyświetlaj Nazwę automatu w jego "pełnej nazwie"</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="ShowMachineLocation" defaultChecked={maintenanceData?.ShowMachineLocation} />
          <label className="form-check-label">Wyświetlaj lokalizacje automatu w jego "pełnej nazwie"</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="HasTelemetry" defaultChecked={maintenanceData?.HasTelemetry} />
          <label className="form-check-label">Telemetria</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsCoinBagMandatory" defaultChecked={maintenanceData?.IsCoinBagMandatory} />
          <label className="form-check-label">Wybór torby na gotówkę jest wymagany</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsOverpayRequired" defaultChecked={maintenanceData?.IsOverpayRequired} />
          <label className="form-check-label">Spisywanie licznika gotówkowego nadpłaty wymagane podczas wybierania monet</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="IsTotalSalesHidden" defaultChecked={maintenanceData?.IsTotalSalesHidden} />
          <label className="form-check-label">Ukryj sprzedaż całkowitą</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="OrderByProduct" defaultChecked={maintenanceData?.OrderByProduct} />
          <label className="form-check-label">Sortuj wybory wg nazw produktów</label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" name="UseCoffeeInventory" defaultChecked={maintenanceData?.UseCoffeeInventory} />
          <label className="form-check-label">Używaj inwentaryzacji stanu automatu kawowego</label>
        </div>
      </form>
    </FormSkel>
  )
}
